import BaseBranding from "%/dynamic-components/render-engine/classes/branding/base-branding";
import useBrandingStore from "%/stores/branding-store";

export default class ButtonBranding extends BaseBranding {
  static inheritanceStructure = {
    base: "primary.standard",
    inherits: {
      "primary.small": ["primary.standard"],
      "primary.large": ["primary.standard"],
      "secondary.standard": ["primary.standard"],
      "secondary.small": ["primary.standard", "secondary.standard"],
      "secondary.large": ["primary.standard", "secondary.standard"],
      "tertiary.standard": ["primary.standard"],
      "tertiary.small": ["primary.standard", "tertiary.standard"],
      "tertiary.large": ["primary.standard", "tertiary.standard"],
    },
  };

  static isThemableOptionKey(optionKey) {
    const keys = Object.keys(useBrandingStore().defaultTemplateConfiguration["ButtonBranding"]["primary"]["standard"]);
    return keys.includes(`default.${optionKey}`);
  }

  findNextInheritanceLevel(variant, size) {
    const key = `${variant}${size ? `.${size}` : ""}`;
    const inheritanceLevels = ButtonBranding.inheritanceStructure.inherits[key] || [];
    const currentLevelIndex = inheritanceLevels.indexOf(size);
    let nextLevel;
    if (currentLevelIndex === -1 || currentLevelIndex === 0) {
      nextLevel = ButtonBranding.inheritanceStructure.base;
    } else {
      nextLevel = inheritanceLevels[currentLevelIndex - 1] || ButtonBranding.inheritanceStructure.base;
    }

    return { variant: nextLevel.split(".")[0], type: nextLevel.split(".")[1] };
  }

  determineType() {
    return "ButtonBranding";
  }

  determineVariant(elementConfig, breakpoint, state, availableBreakpoints) {
    const type = this.processInheritance(elementConfig.options, "button-type", breakpoint, state, availableBreakpoints);
    return type || "primary";
  }

  determineSize(elementConfig, breakpoint, state, availableBreakpoints) {
    const size = this.processInheritance(elementConfig.options, "button-size", breakpoint, state, availableBreakpoints);
    return size || "standard";
  }
}
